var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { Specialist as SpecialistModel } from '@/models/Specialist';
import PageHeader from '@/components/page-header/PageHeader';
import DataTable from '@/components/data-table/DataTable';
import { fileToBase64, formatDate } from '@/support/String';
import { Token } from '@/support/Token';
import ErrorHandler from '@/support/ErrorHandler';
import ImageInput from '@/components/dialog/image-input/ImageInput';
import { cloneDeep } from 'lodash';
import { RolesEnum } from '@/items/Roles';
import ConfirmRemoveMfaDialog from '@/components/ConfirmRemoveMfaDialog/ConfirmRemoveMfaDialog.vue';
let Specialist = class Specialist extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Specialist';
        this.isEditing = false;
        this.isEditingDob = false;
        this.formatDob = formatDate;
        this.specialist = new SpecialistModel();
        this.specialistClone = new SpecialistModel();
        this.file = null;
        this.baseImage = null;
        this.isChangingAvatar = false;
        this.passwordHidden = true;
        this.password = {
            old: '',
            new: '',
            confirmation: '',
        };
        // #region RemoveMFA
        this.isConfirmRemoveMfaDialogOpen = false;
        // #endregion
    }
    get breadcrumbs() {
        return [
            { name: 'Users' },
            { name: 'Specialists', path: '/specialists' },
            { name: this.specialist.name || '', path: this.$route.path },
        ];
    }
    mounted() {
        new SpecialistModel()
            .include('token')
            .find(this.$route.params.id)
            .then((specialist) => {
            this.specialist = specialist;
            this.specialistClone = cloneDeep(specialist);
        });
    }
    update() {
        this.isEditing = false;
        if (this.password.new.length === 0) {
            this.resetPassword();
        }
        else {
            this.specialist.password = this.password.new;
        }
        const payload = this.specialist.getPayload();
        if (payload.avatar) {
            delete payload.avatar;
        }
        this.specialist
            .include(['specialist', 'roles'])
            .update(payload)
            .then((specialist) => {
            this.resetPassword();
            this.specialist = specialist;
            this.specialistClone = cloneDeep(specialist);
            this.updateCurrentUser(specialist);
        });
    }
    resetPassword() {
        delete this.specialist.password;
        delete this.specialist.current_password;
        this.password = {
            old: '',
            new: '',
            confirmation: '',
        };
    }
    setToken() {
        Token.setLoginAsToken(this.specialist.token.bearer);
        const url = `${window.location.protocol}//${window.location.host}`;
        window.location.href = url;
    }
    updateCurrentUser(specialist) {
        if (specialist.id === this.$store.state.Auth.id) {
            this.$store.dispatch('userAuthenticated', specialist);
        }
    }
    changeAvatar(event) {
        if (event.target === null || event.target.files === null || !event.target.files.length) {
            return;
        }
        this.file = event.target.files[0];
        fileToBase64(this.file).then((encodedFile) => {
            this.baseImage = encodedFile;
            this.isChangingAvatar = true;
        });
    }
    async changingCurrentAvatar() {
        const specialistWithDataObjects = await new SpecialistModel()
            .include(['data_objects'])
            .find(this.$route.params.id);
        if (specialistWithDataObjects) {
            this.baseImage = specialistWithDataObjects.data_objects.avatar;
            this.isChangingAvatar = true;
        }
    }
    avatarChanged(imageUrl) {
        this.specialist
            .include(['specialist', 'roles'])
            .update({ avatar: imageUrl })
            .then((specialist) => {
            this.specialist.avatar = imageUrl;
            this.updateCurrentUser(specialist);
            this.specialistClone = cloneDeep(specialist);
            this.$emit('closed', false);
            this.isChangingAvatar = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    get isAuthorized() {
        return this.$store.state.Auth.hasRole([
            RolesEnum.ADMIN,
            RolesEnum.ROOT,
            RolesEnum.TRAINER,
            RolesEnum.MANAGER,
        ]);
    }
    get canRemoveMfa() {
        return this.$store.state.Auth.hasRole([RolesEnum.ROOT, RolesEnum.ADMIN]);
    }
    get removeMfaEnabled() {
        return !!this.specialist.has_mfa_token;
    }
    async removeMfa() {
        if (this.specialist) {
            const specialist = await this.specialist
                .update({ mfa_token: null })
                .catch((error) => {
                ErrorHandler.network(error);
                return null;
            });
            if (specialist) {
                this.$set(this.specialist, 'has_mfa_token', false);
                if (this.specialistClone) {
                    this.$set(this.specialistClone, 'has_mfa_token', false);
                }
            }
        }
        this.isConfirmRemoveMfaDialogOpen = false;
    }
};
Specialist = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            ImageInput,
            ConfirmRemoveMfaDialog,
        },
    })
], Specialist);
export default Specialist;
